import { Sparkle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router";
import { AI_ASSISTANT_ROUTES } from "@/src/ai-assistant/constants/ai-assistant-routes.constants";
import { clsx } from "@/src/common/utils/clsx";

export function AiAssistantSidebarItem() {
	const { t } = useTranslation("common");

	return (
		<NavLink
			to={AI_ASSISTANT_ROUTES.chat}
			className={() =>
				clsx(
					"group flex items-center gap-3 rounded-md px-3 py-2.5 text-sm font-semibold shadow-sm transition-colors",
					"bg-primary text-primary-foreground hover:bg-primary-400 dark:hover:bg-primary-600",
				)
			}
		>
			<span className="inline-flex size-4 shrink-0 origin-center group-hover:animate-sparkle-bounce">
				<Sparkle className="size-4" aria-hidden />
			</span>
			<span className="flex-1 truncate">{t("nav.ai_assistant")}</span>
		</NavLink>
	);
}
